import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, Grid } from "@mui/material";
import { Add } from "@mui/icons-material";
import LoadingButton from '@mui/lab/LoadingButton';
import { t } from "i18next";
import MDBox from "components/MDs/MDBox";
import MDTypography from "components/MDs/MDTypography";
import DashboardLayout from "../LayoutContainers/DashboardLayout";
import AppConfig from "../../helpers/constants/AppConfig";
import api from "../../helpers/api/Api";
import { showStatus } from "../../helpers/api/errors/ShowStatus";

function AddLayout({ children, title, postFormData, addUrl, listUrl, onClick, isEdit, setOpenDialog }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  // fetch add api when postFormData is ready
  useEffect(() => {
    if (postFormData) {
      addItem();
    }
  }, [postFormData]);

  const addItem = () => {
    setLoading(true);
    const snackArgs = {
      item: title,
      op: isEdit ? t("global.edit") : t("global.add")
    };

    api.post(addUrl, postFormData)
      .then((response) => {
        setLoading(false);
        showStatus(
          response.data.message === "domain exists" ? "domain exists" : response.data.status,
          snackArgs
        );
        if (response.data.status === "success") {
          if (setOpenDialog && !isEdit) {
            setOpenDialog(true);
          } else {
            navigate(listUrl);
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error", snackArgs);
      });
  }

  return (
    <DashboardLayout>
      <MDBox pb={3}>
        <Grid container spacing={6} rowSpacing={3} >
          <Grid item xs={12}>
            <MDBox
              mb={3}
              py={3}
              px={2}
              variant="gradient"
              bgColor={AppConfig.color}
              borderRadius="lg"
              coloredShadow={AppConfig.color}
            >
              <MDTypography variant="h6" color="white">
                {t(isEdit ? "page.edit" : "page.add", { item: title })}
              </MDTypography>
            </MDBox>

            <Card>
              <MDBox py={3} px={5}>
                <Grid container spacing={2} justifyContent="center" sx={{ mt: 1, mb: 2, ml: 0 }} >

                  <Grid container spacing={2} rowSpacing={2} p={2}>
                    {children}
                  </Grid>

                  <Grid container justifyContent="center" mt={4}>
                    <Grid item md={4}>
                      <LoadingButton
                        color={AppConfig.color}
                        loading={loading}
                        startIcon={<Add />}
                        variant="outlined"
                        fullWidth
                        onClick={onClick}
                      >
                        {t(isEdit ? "button.edit" : "button.add", { item: title })}
                      </LoadingButton>
                    </Grid>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default AddLayout;
